import Vue from 'vue'
import { apiGuest } from '@/api/Guest'
import i18n from '@/lang/i18n'

/**
 * 確認訪客登記資料的狀態
 * 1. 如果「已取消登記」或「已抵達」、「已離開」，則視為結束
 * @param {number} guestId 訪客預約資料的ID
 * @param {boolean} hasOpener 是否由別的視窗開啟
 */
export const confirmGuestReservationStatus = async (guestId, hasOpener = false) => {
  let isFinished = false
  const loading = Vue.prototype.$loading()
  try {
    const { status, data } = await apiGuest.PlusGuestReservation.GetGuestData({ id: guestId })
    if (status === 200) {
      const finishedStatuses = {
        3: i18n.t('Guest.DuplicateGuestDataNoActionRequired'),
        4: i18n.t('Guest.DuplicateGuestDataNoActionRequired'),
        5: i18n.t('Guest.GuestAppointmentCancelled')
      }

      if (finishedStatuses[data.GuestStatusId]) {
        isFinished = true
        Vue.prototype.$msgbox({
          title: '提示',
          customClass: 'message-box-alert',
          message: finishedStatuses[data.GuestStatusId],
          showCancelButton: false,
          roundButton: true,
          confirmButtonText: '確定'
        }).then(() => {
          if (hasOpener) {
            window.opener = null
            window.close()
          }
        }).catch(() => {})
      }
    }
  } catch (error) {
    console.log(error)
  } finally {
    loading.close()
    return isFinished
  }
}

/**
  * 格式化車牌號碼
  * 1. 只允許輸入英數字和 dash 符號
  * 2. 英文字母自動轉大寫
  * 3. 限制最多8個字元(包含dash符號)
  * @param {string} licensePlateNumber 車牌號碼
  * @returns {string} 格式化後的車牌號碼
  */
export const formatLicensePlateNumber = (licensePlateNumber) => {
  if (!licensePlateNumber) return ''

  // 只保留英數字和 dash 符號，並轉為大寫
  const formattedValue = licensePlateNumber
    .replace(/[^a-zA-Z0-9-]/g, '') // 移除非英數和 dash 符號
    .toUpperCase() // 英文自動轉大寫
    .substring(0, 8) // 限制最多8個字元

  return formattedValue
}
